<ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" > صور المشروع</h4>
      <button type="button" class="close"  (click)="modalclose()"  data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12">
              <!-- <button class="btn btn-success" appActionNew (click)="New()">جديد</button> -->
                <div  class="card">
                    <div class="card-header px-0 " style="padding-bottom: 5px;">
                        <form [formGroup]="insertForm" (ngSubmit)="Submit()">
    
                        <div class="row m-0 mb-2">
                            <div class="col-md-4 ">
                              <label for=""> الاسم
                              </label>
                                <div class="form-group">
                                    
                                   <input type="text"  class="form-control" formControlName="title" 
                                   [tooltip]="fc.title.errors?.required ? ' الاسم مطلوب' : null" required
                                   [isDisabled]="!((fc.title.errors?.required && fc.title.touched))"
                                   containerClass="" [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                   [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                                   >
                                </div>
                            </div>
                              <div class="col-md-4 text-center">
                                <label for="" style="    font-size: large;"> المشروع
                                </label>
                                  <div class="form-group">
                                    <label for="" style="    font-size: large;"> {{ProjectName}}
                                    </label>    

                                  </div>
                              </div>
                            <div  class="col-md-4">
                            <button  [disabled]="disabled"  type="button" class="btn   addbtn w-100 h-50 mt-4 " color="primary" (click)="fileInput.click()">
                              <span>Upload Image</span>
                              <input #fileInput type="file"   
                              accept="video/*,image/*" (change)="onFileSelected($event,i)" style="display:none;" />
                            </button>  
                            </div>
                            <div class="row m-0" > 
                              <div class="image-area" style="margin: 8px;"  >
                                
                                  <img  *ngIf="imagesView && ShowPhoto" src="{{imagesView}}"  height="100" width="100"  (click)="OpenImage(imagesView)">
                                  <video *ngIf="imagesView && !ShowPhoto" width="320" height="240" controls>
                                    <source src="{{imagesView}}" type="video/mp4">
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                                
                                <a *ngIf="imagesView" class="remove-image" (click)="deleteimage(i)" style="display: inline;">&#215;</a>

                      </div>
                    </div>
                        </form>  
                        <div *ngIf="Loader"  style="height: 0px !important; text-align: start !important;" class="loader-box">
                          <div  class="loader-3" ></div>
                        </div>
                        <br>
                              <button type="button" class="btn btn-danger float-left mr-3" [disabled]="disabled" (click)="modalclose()" >رجوع</button>
        <button  type="button" style="height: 35px;" class="btn  float-left" [disabled]="disabled" (click)="Submit();">حفظ</button>
    
        

        </div>
    </div>
            </div>
            <!-- <div class="modal-footer">
   
            </div> -->
          <div class="col-sm-12">
            <div class="card">
               <div class="row"  style=" padding: 30px;">
                 <div  *ngFor="let item of ProjectImages let i =index" style="width: 2%;" class="col-4">
                  <!-- <img class="m-3" src="../../../../../assets/images/User.jpg"> -->
                  <div class="image-area text-center bg-white" style="margin: 8px;"  >
                    <img     [src]="item.image"  height="200" width="200"  (click)="OpenImage(item.image)">
                    <!-- <video *ngIf="item.mediaTypeId==11"  height="200" width="200" controls>
                      <source [src]="item.image" >
                      Your browser does not support the video tag.
                    </video> -->
                    <a  class="remove-image" appActionDelete (click)="deleteProjectImage(item.id)" style="display: inline;">&#215;</a>
                    <br>
                    <p style="font-size: medium;">
                      {{item.title}}</p>

                  </div>
                 </div>
               </div>
  
</div>
        </div>
        </div>
     
    </div>
 
  </ng-template>

<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div class="row">
                        <div class="col-6">
                            <h5 class="pb-2">المشاريع</h5>
                    
                        </div>

                        <div class="col-6 header-titles">
                            <a routerLink="/content/admin/insert-project" class="d-block">
                                <button class="btn pull-right" type="button">
                                    <span class="m-2">إدخال مشروع</span>
                                    <i class="fa fa-plus"></i>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="card-block row">
                    <div class="col-sm-12 col-lg-12 col-xl-12">
                        <div class="table-responsive">
                            <table class="table table-responsive-sm">
                                <thead>
                                    <tr class=" ">
                                        <th scope="col"></th>
                                        <th scope="col">اسم المشروع</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let view of Projects;let x = index" class=" ">
                                        <td scope="row" class="p-2">{{x+1}}</td>
                                        <td class="p-2">{{view.title}}</td>
                                            <td class="font-style chose">
                                              <button class="btn pull-right"
                                              style="color: rgba(35, 118, 241, 0.667); padding: 7px"
                                              (click)="GotoProjectCompletion(view.id)" >
                                              <!-- <i class="fa fa-picture-o"></i> -->
                                              انجازات المشروع
                                          </button>
                                                <button  style="padding: 7px; color: rgba(35, 118, 241, 0.667);" (click)="open(content,view);">
                                                    <!-- <i class="fa fa-upload"></i> -->
                                                 <i class="fa fa-picture-o"></i>
                                                  </button>
                                              
                                                <button class="btn pull-right"
                                                style="color: rgba(35, 118, 241, 0.667); padding: 7px"
                                                (click)="update(view.id)">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                                   <button class="btn  pull-right"  style="color: red; padding: 7px"
                                                   (click)="delete(view.id)">
                                                    <i class="fa fa-trash"></i>
                                                       </button>
                                               
                                            
                                            </td>
                                        </tr>
                                </tbody>
                            </table>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-center">
      <pagination [boundaryLinks]="true" [maxSize]="5" [totalItems]="totalCount" previousText="&lsaquo;" nextText="&rsaquo;"
        firstText="&laquo;" lastText="&raquo;" [itemsPerPage]="pager.maxResultCount" [(ngModel)]="pageNumber"
        (pageChanged)="pageChanged($event)">
      </pagination>
    </div>
</div>




